module.exports = __webpack_public_path__ + "img/41.89788d67.jpg";